import styled from 'styled-components';

export const WalletTabContainer = styled.section`
	align-items: center;
	display: flex;
	flex: 1;
	flex-flow: column;

	padding: ${({ theme }) =>
		`${theme.spacings.medium} ${theme.spacings.small} ${theme.spacings.small} ${theme.spacings.small}`};
	${({ theme }) => theme.breakpoints.queries.above.mobile} {
		padding: ${({ theme }) =>
			`${theme.spacings.medium} ${theme.spacings.large} ${theme.spacings.large} ${theme.spacings.large}`};
	}
	${({ theme }) => theme.breakpoints.queries.above.tabletSmallDesktop} {
		padding: ${({ theme }) =>
			`${theme.spacings.medium} ${theme.spacings.xxlarge} ${theme.spacings.xxlarge} ${theme.spacings.xxlarge}`};
	}
`;
